import { render, staticRenderFns } from "./ReverseNumber.vue?vue&type=template&id=f893083e&scoped=true"
import script from "./ReverseNumber.vue?vue&type=script&lang=js"
export * from "./ReverseNumber.vue?vue&type=script&lang=js"
import style0 from "./ReverseNumber.vue?vue&type=style&index=0&id=f893083e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f893083e",
  null
  
)

export default component.exports